import { type FunctionComponent } from 'react';

export type Currency = 'EURO' | 'POUND_STERLING';

export type SizeType = 'DEFAULT' | 'PROMOTED';

export type Tax = 'withoutVAT' | 'VAT';

export type TopLeftLabel = 'bulk' | 'coupon' | 'proPriceAdvantage';

export type MiddleLabel =
  | 'sponsored'
  | 'topSale'
  | 'promo'
  | 'bestQualityOffer'
  | 'ecoResponsible'
  | 'blackFriday'
  | 'sales'
  | 'manomanoDays'
  | 'secondHand'
  | 'madeIn'
  | 'inStock'
  | 'loweredprice';

export type ThirdLineLabel = 'ecoResponsible' | 'madeIn' | string;

export type ProductCardTag = TopLeftLabel | MiddleLabel | ThirdLineLabel;

export const enum productLabels {
  SPONSORED = 'sponsored',
  PROMO = 'promo',
  COUPON = 'coupon',
  ECO_RESPONSIBLE = 'ecoResponsible',
  MADE_IN = 'madeIn',
  TOP_SALE = 'topSale',
  BLACKFRIDAY = 'blackFriday',
  SALES = 'sales',
  MANOMANODAYS = 'manomanoDays',
  PRO_PRICE_ADVANTAGE = 'proPriceAdvantage',
  BULK = 'bulk',
  BEST_QUALITY_OFFER = 'bestQualityOffer',
  IN_STOCK = 'inStock',
  SECOND_HAND = 'secondHand',
  LOWERED_PRICE = 'loweredprice',
}

export interface ProductCardListingsTranslations {
  informationLine: {
    alternativeModel: string;
  };
  legalMention: {
    mention: string;
    mentionNoVAT?: string;
  };
  price: {
    VAT: string;
    withoutVAT: string;
  };
  addToCart: {
    label: string;
    success: string;
    error: string;
  };
  deliveryLabel: {
    freeDelivery: string;
    fastDelivery: string;
    freeDeliveryByMM: string;
    fastDeliveryByMM: string;
  };
  tags: {
    inStock: {
      label: string;
    };
    sponsored: {
      label: string;
      description: FunctionComponent | string;
    };
    topSale: {
      label: string;
    };
    promo: {
      label: string;
    };
    bulk: {
      label: string;
    };
    bestQualityOffer: {
      label: string;
    };
    coupon?: {
      label: string;
      labelShort: string;
    };
    ecoResponsible: {
      label: string;
    };
    madeIn: {
      label: string;
    };
    secondHand?: {
      label: string;
    };
    blackFriday?: {
      label: string;
    };
    sales?: {
      label: string;
    };
    manomanoDays?: {
      label: string;
    };
    options: {
      label: string;
    };
    proPriceAdvantage?: {
      label: string;
    };
    loweredprice?: {
      label: string;
    };
  };
}
